import { toast as sonnerToast } from 'sonner'

// Create a safe toast utility that works outside React components
export const toast = {
  error: (message: string) => {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
      sonnerToast.error(message)
    }
  },
  success: (message: string) => {
    if (typeof window !== 'undefined') {
      sonnerToast.success(message)
    }
  },
  // Add other toast types as needed
} 